// Module
var code = "<h2 id=\"payment-processing-information\">Payment Processing Information</h2> <p>Choose how extra payments are applied to your loans and find out when we process your payments.</p> ";
// Exports
export default code;